import {
    ApiOutlined,
    AuditOutlined,
    BarsOutlined,
    ControlOutlined,
    DoubleLeftOutlined,
    DoubleRightOutlined,
    FieldTimeOutlined,
    FileDoneOutlined,
    LeftOutlined,
    NotificationOutlined,
    PauseOutlined,
    ReconciliationOutlined,
    RightOutlined,
    ScheduleOutlined,
} from '@ant-design/icons';
import React from 'react';

export const getIconByPriorityTask = (priorityCaption: number) => {
    switch (priorityCaption) {
        case 501:
            return <DoubleLeftOutlined rotate={90} style={{ color: 'red' }} />;
        case 502:
            return <LeftOutlined rotate={90} style={{ color: 'red' }} />;
        case 503:
            return <PauseOutlined rotate={90} style={{ color: 'orange' }} />;
        case 504:
            return <RightOutlined rotate={90} style={{ color: 'blue' }} />;
        case 505:
            return <DoubleRightOutlined rotate={90} style={{ color: 'blue' }} />;
        default:
            return <DoubleLeftOutlined rotate={90} style={{ color: 'red' }} />;
    }
};

export const getTaskTypeIcon = (iconId: string, fontSize: number) => {
    switch (iconId) {
        case '521': //'Action Item'
            return <FieldTimeOutlined style={{ fontSize }} />;
        case '522': //'Meeting'
            return <ReconciliationOutlined style={{ fontSize }} />;
        case '523': //'Monitoring'
            return <ControlOutlined style={{ fontSize }} />;
        case '524': //'Supervision'
            return <AuditOutlined style={{ fontSize }} />;
        case '525': //'Inspection'
            return <FileDoneOutlined style={{ fontSize }} />;
        case '526': //'Milestone'
            return <NotificationOutlined style={{ fontSize }} />;
        case '528': //'Subtask'
            return <BarsOutlined style={{ fontSize }} />;
        case '529': //'Schedule'
            return <ScheduleOutlined style={{ fontSize }} />;
        case '527': //'Unavailable'
        default:
            return <ApiOutlined style={{ fontSize }} />; //ApiFilled
    }
};

export const defaultIconTaskType = () => <ApiOutlined style={{ fontSize: 16 }} />;

export const getIconOwnerTask = () => {};
